export default "__VITE_ASSET__2159242a__"